/**
 * Enum que define los tipos de modal de uso genérico.
 */
export enum ModalTipoEnum {
  GUARDAR = 'Guardar',
  RESTAURAR = 'Restaurar',
  SALIR = 'Salir',
}
